import { defineStore } from 'pinia'

export const useUiStateStore = defineStore('ui-state', {
  // Persist this store to localStorage (via pinia-plugin-persistedstate plugin)
  persist: true,

  state: () => ({
    registersAreDirty: false,
    /** @type {{ start: string, end: string }} */
    filterDateRange: {},
    /** @type {{ start: string, end: string }} */
    dashboardDates: {},
    /** @type {Object | null} */
    dashboardSettings: null,
    /** @type {boolean} */
    showOnboardList: false,
    /** @type {boolean} */
    isOnboardingRoute: false,
    /** @type {boolean} */
    staffSalesReportViewNew: true
  })
})
